export default __webpack_public_path__ + "static/media/apple.6a78fed1.png";